import Image from "next/image";
import Link from "next/link";
import { useLineQuoteUrl } from "lib/line";

export default function Hero() {
  const lineUrl = useLineQuoteUrl();

  return (
    <section className="relative isolate overflow-hidden bg-[#fffdf6] text-gray-950">
      <div className="absolute right-[-14rem] top-[-12rem] -z-10 h-[42rem] w-[42rem] rounded-full bg-brand/25" />

      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-10 px-6 py-12 sm:px-8 sm:py-14 lg:min-h-[620px] lg:grid-cols-[1.15fr,0.85fr] lg:gap-10 lg:py-16">
        <div className="flex items-center">
          <div className="max-w-3xl">
            <h1 className="max-w-[15ch] text-[2.25rem] font-semibold leading-[1.3] text-gray-950 min-[390px]:text-[2.5rem] sm:max-w-3xl sm:text-5xl sm:leading-[1.2] lg:max-w-none lg:text-[3.45rem] lg:leading-[1.18]">
              <span className="block">บริการบัญชีและภาษี</span>
              <span className="mt-2 block sm:mt-3">สำหรับธุรกิจในเชียงใหม่</span>
            </h1>
            <p className="mt-5 max-w-2xl break-words text-base leading-8 text-slate-600 sm:mt-6 sm:text-lg lg:text-xl">
              ดูแลตั้งแต่จดทะเบียนธุรกิจ ทำบัญชีและยื่นภาษีรายเดือน จนถึงปิดบัญชีประจำปี
              พร้อมแจ้งรายการเอกสารและกำหนดส่งในแต่ละรอบอย่างชัดเจน
            </p>

            <div className="mt-7 flex w-full max-w-[calc(100vw-3rem)] flex-col gap-3 sm:mt-8 sm:max-w-none sm:flex-row sm:items-center">
              <a href={lineUrl} target="_blank" rel="noreferrer" className="btn-primary min-h-12 w-full px-5 sm:w-auto sm:px-7">
                สอบถามบริการทาง LINE <span aria-hidden className="ml-2">→</span>
              </a>
              <Link href="#services" className="btn-secondary min-h-12 w-full px-5 sm:w-auto sm:px-7">
                ดูบริการและค่าบริการ
              </Link>
            </div>

          </div>
        </div>

        <div className="relative mx-auto aspect-[3/2] w-full max-w-[calc(100vw-3rem)] sm:max-w-[560px]">
          <div className="absolute inset-5 rounded-[2.5rem] bg-brand sm:inset-8" />
          <div className="absolute inset-x-0 bottom-0 top-12 overflow-hidden rounded-[2.5rem] border-[10px] border-white bg-white shadow-[0_30px_70px_-35px_rgba(80,65,0,0.35)]">
            <Image
              src="/images/hero-cover.jpg"
              alt="ภาพประกอบการตรวจสอบข้อมูลทางบัญชีและภาษี"
              fill
              className="object-cover object-center brightness-[1.12] saturate-[0.85]"
              sizes="(min-width: 1024px) 44vw, 100vw"
              priority
              quality={82}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-gray-950/20 via-transparent to-white/5" />
          </div>
        </div>
      </div>
    </section>
  );
}
